import { differenceInMilliseconds } from 'date-fns';
import { useNetworkStore } from '../../hooks/useNetworkStore';
import { tabInactiveThresholdMs } from '../../lib/config';

export const useTradingViewPaused = () => {
  const isOnline = useNetworkStore((state) => state.isOnline);
  const isTabVisible = useNetworkStore((state) => state.isTabVisible);
  const lastBackgroundTime = useNetworkStore((state) => state.lastBackgroundTime);
  if (!isOnline) {
    return true;
  }
  if (
    !isTabVisible &&
    lastBackgroundTime &&
    differenceInMilliseconds(new Date(), new Date(lastBackgroundTime)) > tabInactiveThresholdMs
  ) {
    return true;
  }
  return false;
};
